export default __webpack_public_path__ + "static/media/city-electric-supply.748f7c2a.png";